<template lang="pug">
EcreativArchetypesHeading.title.mb-3(v-if="resolvedTitle" tag="h3" :context="linkColor") {{ resolvedTitle }}
ul.menuList.list-unstyled
  EcreativArchetypesDestinationItemArchetype.menuList__item.pb-3(
    v-for="item in resolvedLinks"
    :key="item.id || item.text"
    v-bind="item"
    :fontWeight="fontWeight"
    :linkColor="linkColor"
    isUnderLine="none"
  )
</template>

<script lang="ts" setup>
/* eslint-disable */
import { type Navigation, type NavigationNode } from 'data-types-config';
import { computed } from 'vue';

type NavInput = Navigation | NavigationNode[];

const props = withDefaults(
  defineProps<{
    /** Navigation object with text (title) and children, or array of DestinationItemArchetype */
    links?: NavInput;
    /** Link color override for all items */
    linkColor?: string;
    title?: string;
    isUnderLine?: 'underline' | 'none' | 'onHover';
    fontWeight?: string;
  }>(),
  {
    links: () => [],
    linkColor: '',
    isUnderLine: undefined,
    title: '',
    fontWeight: '',
  },
);

const resolvedLinks = computed(() => {
  if (Array.isArray(props.links)) {
    return props.links;
  }
  return props.links?.children || [];
});

const resolvedTitle = computed(() => {
  if (props.title) return props.title;
  if (!Array.isArray(props.links)) {
    return props.links?.title || props.links?.text || '';
  }
  return '';
});
</script>

<style lang="scss" scoped>
/* stylelint-disable selector-no-qualifying-type */

.title {
  font-size: clamp(1rem, 2vw, 1.4rem);
}

.menuList {
  &#{&} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: start;

    @include media-breakpoint-up(md) {
      overflow-x: hidden;
    }
  }

  &__item {
    :deep(.btn-) {
      font-size: clamp(0.8rem, 2vw, 0.9rem);
    }

    @include media-breakpoint-up(md) {
      padding: 0 0 clamp(0.4rem, 1vw, 0.5rem);
    }
  }
}
</style>
